import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastService } from '../../../../@theme/service/toast.service';
import { ProductService } from '../../../../pages/product/product.service';
import { Objects } from '../../../util/objects';

@Component({
  selector: 'ngx-product-search-column',
  template: ` <nb-icon class="mr-1" *ngIf="params.value" icon="search-outline" style="cursor: pointer" status="primary" (click)="onClickSearch()"></nb-icon>
                <span (click)="onClickSearch()" style="cursor: pointer">{{ params.value }}</span>
               `,
  encapsulation: ViewEncapsulation.None,
})
export class ProductSearchComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public data: any;
  public original: boolean = false;

  constructor(
    private productService: ProductService,
    private toast: ToastService
  ) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;

    if (this.params.hasOwnProperty('original'))
      this.original = Objects.safeGetValue(this.params, 'original', false);
  }

  ngOnInit() {}

  onClickSearch(): void {
    let productCode: number = this.original ? this.data.code : (this.data.productCode ? this.data.productCode : this.data.code);

    if (productCode === undefined)
      productCode = this.data?.aiLabel;

    this.productService.exists(productCode).subscribe((res) => {
      if (res && res.result && res.data) {
        const baseUrl = window.location.origin;
        const url = `${baseUrl}/#/pages/product/${productCode}`;
        window.open(url, '_blank', 'toolbar=0,location=0,menubar=0,width=800,height=600');
      } else {
        this.toast.showToast('warning', '제품정보가 존재하지 않습니다.');
      }
    });
  }
}
